/** 1 = Cost 2 = Safety 3 = Regularitory 4 = Reputation 5 = Environment */
export enum RiskAssesmentType {
    Cost = 1,
    Safety = 2,
    Regularitory = 3,
    Reputation = 4,
    Environment = 5,
}